import { render } from "./Home.vue?vue&type=template&id=13aca46a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=13aca46a&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13aca46a"]])

export default __exports__